exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn {\n    color: #fff;\n    background-color: #5cb85c;\n    border-color: #4cae4c;\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.3333333;\n    border-radius: 6px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/button/button.component.css
// module id = ../../../../../src/app/shared/button/button.component.css
// module chunks = main